module.exports = __webpack_public_path__ + "img/memomemo.4c766ee3.svg";